module.exports = __webpack_public_path__ + "static/media/store.01b552c0.png";